export const Loader = () => {
  return (
    <div className="fixed inset-0 z-50 bg-white flex justify-center items-center">
      <div className="loader" />
    </div>
  );
};
